import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '女主是谁', href: '#female-lead' },
  { label: '男主设定', href: '#male-lead' },
  { label: '人物关系', href: '#relations' },
  { label: '角色图鉴', href: '#gallery' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 shadow-soft backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg text-foreground-950 md:text-xl">
            泡在我家的辣妹
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#gallery"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            开始入坑
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#gallery"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm text-background-50 hover:bg-primary-600"
            >
              开始入坑
            </a>
          </div>
        </div>
      )}
    </header>
  );
}